<script>
// import countTo from "vue-count-to";
 import axios from 'axios';
// import Swal from 'sweetalert2';
// import { TimeAgo } from "vue2-timeago";
// import "vue2-timeago/dist/vue2-timeago.css";
const moment = require('moment');
import { TimeAgo } from "vue2-timeago";

/**
 * Stat component
 */
export default {
    components: {
        // countTo,
         TimeAgo,
    },
    data() {
        return {
           totalTicket:0,
           lastMonthTicket:0,
           dataCloseTicket:0,
           countCloseTicket:0,
           countOpenTicket:0,
           dataOpenTicked:0,
           dataOpenTicketHigh:0,
           dataOpenTicketLow:0,
           dataTicketlastMonth:0,
           lastestStageUpdate:0,
           lastestStageUpdateHolder:{
            noTicket:0,
            status:0,
           },
           lastestTicketStageHolder:0,
           stageItems:[],
           lastestTicketHolder:{
            noTicket:0,
            orderId:0,
           },
           holderAllTicketMonthly:null,
           lastestTicket:0,
           itemsStage:[],
           textvalue:"isisiisis",
           valueTesting:"",
           textUpdateMenu:['Mengatur Petugas','Update Status','Update Stage','Delete'],
           selectedMenuUpdatedTicket:"",
           
              fields: [
              {
                label: "Status",
                key: "code",
                value:"code",
                formatter: (value) => {
                if (value == 'ticketSubmitted'){
                  return "Ticket Dibuat"
                }
                else if (value == 'ticketProgressDone'){
                  return "Proses Selesai"
                }
                else if(value == 'ticketDone'){
                  return "Ticket Selesai"
                }
                },
                sortable: true,
              },
              {
                label: "Di Update Oleh",
                key: "createdBy",
                sortable: true,
              },
              {
                key: "createdAt",
                label: "Tanggal Dibuat",
                sortable: true,
                formatter: (value) => {
                  return moment(value).format("MM-DD-YYYY HH:ss")
                },
              },

              { key: 'actions', label: '' }
                  ],
                  fieldsLastestUpdate: [
              {
                label: "Status",
                key: "code",
                value:"code",
                formatter: (value) => {
                if (value == 'ticketSubmitted'){
                  return "Ticket Dibuat"
                }
                else if (value == 'ticketProgressDone'){
                  return "Proses Selesai"
                }
                else if(value == 'ticketDone'){
                  return "Ticket Selesai"
                }
                },
                sortable: true,
              },
              {
                label: "Di Update Oleh",
                key: "createdBy",
                sortable: true,
              },
              {
                key: "createdAt",
                label: "Tanggal Dibuat",
                sortable: true,
               
              },

              { key: 'actions', label: '' }
            ],

                fieldsLastTicket: [
              {
                label: "Status",
                key: "code",
                value:"code",
                formatter: (value) => {
                if (value == 'ticketSubmitted'){
                  return "Ticket Dibuat"
                }
                else if (value == 'ticketProgressDone'){
                  return "Proses Selesai"
                }
                else if(value == 'ticketDone'){
                  return "Ticket Selesai"
                }
                },
                sortable: true,
              },
              {
                label: "Di Update Oleh",
                key: "createdBy",
                sortable: true,
              },
              {
                key: "createdAt",
                label: "Tanggal Dibuat",
                sortable: true,
                formatter: (value) => {
                  return moment(value).format("MM-DD-YYYY HH:ss")
                },
              },

              { key: 'actions', label: '' }
                  ],

              fieldsDataCloseTicket:[
              {
                label: "Nomor Ticket",
                key: "noTicket",
                sortable: true,
                thStyle: { width: "15%" },
              },
              {
                label: "Nama Pelanggan",
                key: "customerName",
                sortable: true,
              },
              {
                label: "Order Id",
                key: "orderId",
                sortable: true,
              },
              {
                label: "Status Ticket",
                key: "status",
                sortable: true,
              },
            
              {
                label: "Prioritas Ticket",
                key: "priority",
                sortable: true,
              },
              {
                label: "Kategori",
                key: "category",
                sortable: true,
              },
              {
                label: "Assignment",
                key: "assignment",
                sortable: true,
              },
              {
                label: "Dibuat Pada",
                key: "createdAt",
                sortable: true,
              },
              
              ],
              fieldsDataOpenTicket:[
              {
                label: "Nomor Ticket",
                key: "noTicket",
                sortable: true,
                thStyle: { width: "15%" },
              },
              {
                label: "Nama Pelanggan",
                key: "customerName",
                sortable: true,
              },
              {
                label: "Order Id",
                key: "orderId",
                sortable: true,
              },
              {
                label: "Status Ticket",
                key: "status",
                sortable: true,
              },
              {
                label:"Stage Ticket",
                key:"stage",
                sortable: true,
              },
            
              {
                label: "Prioritas Ticket",
                key: "priority",
                sortable: true,
              },
              {
                label: "Kategori",
                key: "category",
                sortable: true,
              },
              {
                label: "Assignment",
                key: "assignment",
                sortable: true,
              },
              {
                label: "Dibuat Pada",
                key: "createdAt",
                sortable: true,
              },
              
              ],

          };


    },

    async created() {
         await this.getStatData()
        
        // console.log('dataFromParent:', this.dataFromParent);
        
        console.log(this.$refs);
        console.log(this.$props);

    },

   
    methods: {
    async showModalUpdate(){
        this.$refs['modal-lastStageUpdate'].show()
    },
    showModalLastest(){
        this.$refs['modal-lastTicket'].show()
    },
    showModalSolved(){
        this.$refs['modal-solved'].show()
    },
    showModalOpen(){
        this.$refs['modal-open'].show()
    },


    hidemodalOpen(){
        this.$refs['modal-open'].hide()
    },


    hidemodalSolved(){
        this.$refs['modal-solved'].hide()
    },
    hidemodal(){
        this.$refs['modal-lastStageUpdate'].hide()
    },
    hidemodalLastTicket(){
         this.$refs['modal-lastTicket'].hide()
        
    },

    async getStatData(){
    await axios.get(process.env.VUE_APP_URL_FEATHERS1 + 'analaytic-dashboard-ticket?stageDetailMountly=true').then(response =>{
        
        
           this.stageItems= response.data.ticketDataPlusDetailMountly.dataLastestTicketUpdate[0].stage
           this.lastestStageUpdate = response.data.ticketDataPlusDetailMountly.dataLastestTicket[0]
           this.totalTicket=response.data.totalTicket
           this.lastMonthTicket=response.data.lastMonthTicket
           this.countOpenTicket=response.data.ticketDataPlusDetailStageStatusOpenMountly.length
           this.countCloseTicket=response.data.ticketDataPlusDetailStageStatusCloseMountly.length
           this.dataCloseTicket=response.data.ticketDataPlusDetailStageStatusCloseMountly
           this.dataOpenTicked=response.data.ticketDataPlusDetailStageStatusOpenMountly
           this.dataTicketlastMonth=response.data.ticketDataPlusDetailMountly.dataTicketMountly
           this.lastestTicket=response.data.ticketDataPlusDetailMountly.dataLastestTicket[0]
           this.holderAllTicketMonthly = response.data.ticketDataPlusDetailMountly.dataTicketMountly
         
      

          if(this.lastestTicket.stage.length > 1){
            this.lastestTicketStageHolder = this.lastestTicket.stage[this.lastestTicket.stage.length-1].stageData.code
              
          }
         else{
          this.lastestTicketStageHolder = this.lastestTicket.stage[0].stageData.code
         
         }
        

           if (this.lastestStageUpdate !== null){
            let lastStage = response.data.ticketDataPlusDetailMountly.dataLastestTicket[0].stage.length-1
            this.lastestStageUpdateHolder.noTicket=response.data.ticketDataPlusDetailMountly.dataLastestTicket[0].noTicket 
            this.lastestStageUpdateHolder.status= response.data.ticketDataPlusDetailMountly.dataLastestTicket[0].stage[lastStage].stageData.code
           }
           this.lastestTicketHolder.noTicket=response.data.ticketDataPlusDetailMountly.dataLastestTicket[0].noTicket
           this.lastestTicketHolder.orderId=response.data.ticketDataPlusDetailMountly.dataLastestTicket[0].orderId

           this.lastestStageUpdate.updateAt = moment(this.lastestStageUpdate.updateAt).format("DD-MM-YYYY HH:ss")
           this.lastestTicket.createdAt= moment(this.lastestTicket.createAt).format("MM-DD-YYYY HH:ss")
           console.log("this.stageItems",this.stageItems);
           console.log("sjdkasdjsa",response.data.ticketDataPlusDetailMountly.dataLastestTicket[0]);


           if( this.lastestStageUpdateHolder.status === "ticketSubmitted")
           this.lastestStageUpdateHolder.status = "Ticket DiBuat"

           if( this.lastestStageUpdateHolder.status === "ticketOnProgress")
           this.lastestStageUpdateHolder.status = "Ticket Dalam Pengerjaan"

           if( this.lastestStageUpdateHolder.status === "Pengerjaan Selesai")
           this.lastestStageUpdateHolder.status = "Ticket DiBuat"

           if( this.lastestStageUpdateHolder.status === "ticketDone")
           this.lastestStageUpdateHolder.status = " Ticket Selesai"
     
    })
},

     

       

    },
};


</script>

<template>
    <div class="row">
        <div class="col-md-6 col-xl-2">
          
            <div class="card"  title="Card Title">
                <div class ="card-title text-center mt-2 mb-0">Total Ticket</div>
                <div class="card-body" style="padding-bottom: 0.625rem;padding-top: 0.625rem;">
                    <h3 class="text-center mt-0 text-info">{{ totalTicket }}</h3>
                    <p class="text-muted mt-2 mb-0 font-size-11">
                        <span class="text-success me-1 ">   
                            <i class="mdi mdi-arrow-up-bold me-1">
                            </i>
                            30
                            <countTo :startVal="0" :endVal="50"
                                :duration="1000" :decimals="2"></countTo>%
                        </span>
                        Dari Sebulan Yang Lalu
                    </p>
                </div>
            </div>
        
        </div>
        <div class="col-md-6 col-xl-2">
            
            <div class="card" >
                <div class ="card-title text-center mt-2 mb-0">Ticket 30 Hari Terakhir</div>
                <div class="card-body" style="padding-bottom: 0.625rem;padding-top: 0.625rem;">
                    <h3 class="text-center mt-0 text-info">{{lastMonthTicket }}</h3>
                    <p class="text-muted mt-2 mb-0 font-size-11">
                        <span class="text-success me-1 ">
                           
                            <i class="mdi mdi-arrow-up-bold me-1">
                            </i>
                            30
                            <countTo :startVal="0" :endVal="50"
                                :duration="1000" :decimals="2"></countTo>%
                        </span>
                        Dari Sebulan Yang Lalu
                    </p>
                </div>
            </div>
        
        </div>
        <div class="col-md-6 col-xl-2">
          <a href="#" @click="showModalOpen">
            <div class="card" >
                <div class ="card-title text-center mt-2 mb-0 pr-2">Open Ticket <span class="badge bg-danger rounded-pill float-end"><i class="mdi mdi-bell-alert text-end">3</i></span></div>
              
                <div class="card-body" style="padding-bottom: 0.625rem;padding-top: 0.625rem;">
                    <h3 class="text-center mt-0 text-danger mb-0">{{ countOpenTicket }}</h3>
                    <p class="text-muted mt-2 mb-0 font-size-11">
                        <span class="text-success me-1 ">
                           
                            <i class="mdi mdi-arrow-up-bold me-1">
                            </i>
                            30
                            <countTo :startVal="0" :endVal="50"
                                :duration="1000" :decimals="2"></countTo>%
                        </span>
                        Dari Sebulan Yang Lalu
                    </p>
                </div>
            </div>
          </a>
        </div>
        <div class="col-md-6 col-xl-2">
             <a href="#" @click="showModalSolved">
            <div class="card" >
                <div class ="card-title text-center mt-2 mb-0">Solved Ticket</div>
                <div class="card-body" style="padding-bottom: 0.625rem;padding-top: 0.625rem;">
                    <h3 class="text-center mt-0 text-success mb-0">{{countCloseTicket}}</h3>
                    <p class="text-muted mt-1 mb-0 font-size-11 ">
                        <span class="text-success me-1 ">
                           
                            <i class="mdi mdi-arrow-up-bold me-1">
                            </i>
                            30
                            <countTo :startVal="0" :endVal="50"
                                :duration="1000" :decimals="2"></countTo>%
                        </span>
                        Dari Sebulan Yang Lalu
                    </p>
                </div>
            </div>
        </a>
        </div>
        <div class="col-md-6 col-xl-2">
           <a href="#" @click="showModalLastest">
            <div class="card">
                <div class ="card-title text-center mt-1 mb-0">Ticket Terbaru</div>
                <div class="card-body" style="padding-bottom: 0.625rem;padding-top: 0.625rem;" >
                   <div class="text-muted mt-0 mb-0 pb-0 pt-0 font-size-11">
                    <p class="mt-0 mb-0">No Ticket : &nbsp;{{ lastestTicketHolder.noTicket }}</p>
                    <p class="mt-0 mb-0">Order Id &nbsp;&nbsp;: &nbsp;{{ lastestTicketHolder.orderId }}</p>
                          <div class="timeago text-success mt-1" >
                                    <time-ago :datetime="lastestTicket.createdAt" refresh tooltip="tooltip" long locale="id" style="margin: 0%; padding: 0%;">
                                    </time-ago>
                          </div>
                   </div>
                </div>
            </div>
        </a>
        </div>
        <div class="col-md-6 col-xl-2">
            
            <a href="#" @click="showModalUpdate">
            <div class="card" style=" background: transparent;
                border-style: groove;
                border-width: 1px 1px 1px 1px;
                border-color: rgb(241, 79, 79);
                border-radius: 0.1rem;">

                <div class ="card-title text-center mt-1 mb-0">Update Ticket Terbaru  <span class="badge bg-danger rounded-pill"><i class="mdi mdi-bell-alert text-end"></i></span></div>
                <div class="card-body" style="padding-bottom: 0.625rem;padding-top: 0.625rem;" >
                   <div class="text-muted mt-0 mb-0 font-size-11">
                    <p class="mt-0 mb-0">No Ticket : {{lastestStageUpdateHolder.noTicket}}</p>
                    <p class="mt-0 mb-0">Status &nbsp;&nbsp; &nbsp; &nbsp;: {{lastestStageUpdateHolder.status}}</p>
                    <div class="timeago text-success mt-1" >
                                    <time-ago :datetime="lastestStageUpdate.updateAt" refresh tooltip="tooltip" long locale="id" style="margin: 0%; padding: 0%;">
                                    </time-ago>
                                </div>
                   </div>
                </div>
            </div>
        </a>
        
        </div>
        <b-modal id="modal-center" ref="modal-lastStageUpdate" centered title="Update Ticket Terbaru " title-class="font-18"
      size ="lg">
        <template #modal-footer>
        <div class="w-100">
          <div class="form-floating mb-3">
          <input type="text" class="form-control" id="floatingInput"  v-model="lastestTicket.customerName" disabled> 
          <label for="floatingInput">Nama Pelanggan</label>
        </div>
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="floatingPassword" v-model="lastestTicket.noTicket" disabled>
          <label for="floatingPassword">Nomor Ticket</label>
        </div>
        <div class="form-floating mb-3">
          <input type="text" class="form-control bg-soft-success" id="floatingPassword" v-model="lastestTicket.status" disabled>
         
         
          <label for="floatingPassword">Status Ticket</label>
        </div>
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="floatingPassword" v-model="lastestTicket.priority" disabled>
          <label for="floatingPassword">Prioritas</label>
        </div>
        <div class="form-floating mb-3" >
          <input type="text" class="form-control" id="floatingPassword" v-model="lastestTicket.category" disabled>
          <label for="floatingPassword">Kategori</label>
        </div>
          <!-- <b-table  head-variant="light" :items="stageItems" :fields="fieldsLastestUpdate" responsive="md"
                show-empty striped>
        
                <template v-slot:cell(Status)>
                  <div class="badge rounded-pill bg-soft-success font-size-12 font-weight-bold" 
                  :class="{
                    'bg-soft-danger': data.items.stageData.code === 'ticketSubmitted',
                    'bg-soft-warning':data.items.stageData.code === 'ticketOnProgress',
                    'bg-soft-warning':data.items.stageData.code === 'ticketProgressDone',
                    'bg-soft-success': data.items.stageData.code === 'ticketDone',
                  }">
                     
                  </div>
                        
                </template>
                <template #empty>
                  <h5>Tidak ada data</h5>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    


                </template>
                <template #table-busy>
                  <div class="text-center  my-2">
                    <b-spinner class="xs-1" variant="primary"></b-spinner>
                    <strong>Memuat data...</strong>
                  </div>
                </template>
               
              </b-table> -->

              <b-card v-for="item in stageItems" :key="item._id" >
                
                <a href="javascript: void(0);"
                            class="text-dark "
                            data-toggle="collapse" 
                            v-b-toggle= "`checkout-kategori-collapse${item.stageData._id}`" >
                <div class="custom-accordion" style="transition: 2s;" >  
                <b-row sm="12" class="mb-1 ">
                            <b-col sm="3"  ><b> Status Pengerjaan:
                              
                            </b>
                              <p class="mt-2" v-if="item.stageData.code === 'ticketSubmitted' "> 
                              <b-button :class="{
                          'badge rounded-pill bg-danger font-size-14 font-weight-bold': item.stageData.code === 'ticketSubmitted'
                        }">
                          Ticket Di Buat
                          
                              </b-button>
                              </p>
                              <p class="mt-2" v-if="item.stageData.code === 'ticketDone' "> 
                              <b-button :class="{
                          'badge rounded-pill bg-success font-size-14 font-weight-bold': item.stageData.code === 'ticketDone'
                        }">
                          Ticket Terselesaikan
                          
                              </b-button>
                              </p>
                              <p class="mt-2" v-if="item.stageData.code === 'ticketOnProgress' "> 
                              <b-button :class="{'badge rounded-pill bg-warning font-size-14 font-weight-bold': item.stageData.code === 'ticketOnProgress'}">
                                Ticket Dalam Pengerjaan
                          
                              </b-button>
                              </p>
                              <p class="mt-2" v-if="item.stageData.code === 'ticketProgressDone' "> 
                              <b-button :class="{'badge rounded-pill bg-info font-size-14 font-weight-bold': item.stageData.code === 'ticketProgressDone'}">
                                Pengerjaan Ticket Selesai
                          
                              </b-button>
                              </p>
                           
                            </b-col>
                          
                            <b-col sm="3"><b> Di Update Oleh</b>
                              <p class="mt-2"> {{item.stageData.createdBy}}</p>
                            </b-col>
                            <b-col sm="3"><b> Tanggal DiBuat</b>
                              <p class="mt-2"> {{item.stageData.createdAt}}</p>
                            </b-col>
                            <b-col sm="2" class="mb-0" ><b>
                              TroubleShoot
                             
                            </b>
                          </b-col>
                            <b-col sm="1" class="mb-0" ><b>
                              <div class="media-body overflow-hidden">
                                  </div>
                                 <p></p>
                                  <i v-if="item.stageDetail !== null" class="mdi mdi-chevron-up accor-down-icon font-size-24"> </i>
                             
                            </b>
                           
                           
                            
                            
                            </b-col>
    

                          </b-row>
                          </div>
                          <b-collapse :id="`checkout-kategori-collapse${item.stageData._id}`" v-if="item.stageDetail !== null ">
                                <div class="p-1 border-top pt-1 " >
                                  <div id="chart" class="mt-3">

                                    <h5><b> Hasil Trouble Shooting</b></h5>
                                    <p></p>
                                    <p></p>
                                    <div class ="text-start " >
                          
                          <h6>Optical Network Unit</h6>
                        
                          <ul >
                          <div class="row">
                            <div class="col-6">
                              <li>
                              <div>
                                <b-input-group class="mb-2">
                                  <b-input-group-prepend style="margin-right: 1.25rem;">
                                    <b-button variant="primary" size ="sm" class="mr-4" disabled pill>&nbsp;&nbsp;oltRx&nbsp;&nbsp;&nbsp;</b-button>
                                  </b-input-group-prepend>

                                  <b-form-input size="sm" style="width: 50%;" :state="true"  :value="item.stageDetail.oltRx" disabled></b-form-input>
                                 
                                  
                                </b-input-group>
                              </div>
                            </li>
                            <li>
                              <div>
                                <b-input-group class="mb-2">
                                  <b-input-group-prepend style="margin-right: 1.25rem;">
                                    <b-button variant="primary" size ="sm" class="mr-4" disabled pill>&nbsp;&nbsp;onuRx&nbsp;</b-button>
                                  </b-input-group-prepend>

                                  <b-form-input size="sm" style="width: 50%;" :state="false" disabled :value="item.stageDetail.onuRx"></b-form-input>
                                  
                                  
                                </b-input-group>
                              </div>
                            </li>
                            <li>
                              <div>
                                <b-input-group class="mb-2">
                                  <b-input-group-prepend style="margin-right: 1.25rem;">
                                    <b-button variant="primary" size ="sm" class="mr-4" disabled pill>&nbsp;&nbsp;Signal&nbsp;</b-button>
                                  </b-input-group-prepend>

                                  <b-form-input size="sm" style="width: 50%;" :state="true"  :value="item.stageDetail.onuSignal"  disabled> </b-form-input>
                                 
                                </b-input-group>
                              </div>
                            </li>
                            </div>
                            <div class="col-6">
                              <li>
                              <div>
                                <b-input-group class="mb-2">
                                  <b-input-group-prepend style="margin-right: 1.2rem;">
                                    <b-button variant="warning" size ="sm" class="mr-4" disabled pill>&nbsp;Onu IP&nbsp;</b-button>
                                  </b-input-group-prepend>

                                  <b-form-input size="sm" style="width: 50%;" :state="true" :value="item.stageDetail.onuIP" disabled></b-form-input>
                                 
                                  
                                </b-input-group>
                              </div>
                            </li>
                            <li>
                              <div>
                                <b-input-group class="mb-2">
                                  <b-input-group-prepend style="margin-right: 1.125rem;" :state="true">
                                    <b-button variant="warning" size ="sm" class="mr-4" disabled pill>Up Time </b-button>
                                  </b-input-group-prepend>

                                  <b-form-input size="sm" style="width: 52%;" :state="true" :value="item.stageDetail.onuUptime" disabled></b-form-input>
                                  
                                  
                                </b-input-group>
                              </div>
                            </li>
                            <li>
                              <div>
                                <b-input-group class="mb-2">
                                  <b-input-group-prepend style="margin-right: 1.25rem;">
                                    <b-button variant="warning" size ="sm" class="mr-4" disabled pill>&nbsp;&nbsp;Status&nbsp; </b-button>
                                  </b-input-group-prepend>

                                  <b-form-input size="sm" style="width: 50%;" :state="true" :value="item.stageDetail.onuState" disabled></b-form-input>
                                  
                                  
                                </b-input-group>
                              </div>
                            </li>
                            </div>
                          </div>
                          <li>
                            <b-card no-body class="mb-1">
                                  <b-card-header header-tag="header" class="p-1" role="tab" title-text="Hasil">
                                    
                                  </b-card-header>
                                
                                    <b-card-body style="padding-left:0px;">
                                      <ul>
                                        <li class="mb-3" v-for ="items in item.stageDetail.result" :key="items"
                                        >
                                      <b-card-text class="text-left"  align="left">{{ items }}</b-card-text>
                                    </li>
                                   
                                  </ul>
                                    </b-card-body>
                                  
                                  
                                </b-card>
                          </li>
                        </ul >
                    
                    </div>
                                    <!-- <apexchart type="bar" height="250" :options="chartOptionsKategoriStacked" :series="seriesKategoriStacked" @click="kategoriBar" ref="seriesKategoriStacked"></apexchart> -->
                                  </div>
                                </div>
                           </b-collapse>
                          </a>
              </b-card>

             
          <b-button
            variant="secondary"
            size="md"
            class="float-end"
            @click="hidemodal"
          >
            Close
          </b-button>

          <b-dropdown id="dropdown-dropup"  text="Update" variant="primary" size="md"
            class="float-start mr-2" dropup v-model="selectedMenuUpdatedTicket" style="margin-right: 6px;"> 
            <b-dropdown-item href="#" v-for="item in textUpdateMenu" :key="item" >{{item}}</b-dropdown-item>
          </b-dropdown>

          
        </div>
      </template>
      <template #modal-header> 
        <h4 >Update Ticket Terbaru </h4></template>

    
        </b-modal>

        <b-modal id="modal-center" ref="modal-lastTicket" centered title="Ticket Terbaru " title-class="font-18">
      
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="floatingInput"  v-model="lastestTicket.customerName" disabled> 
          <label for="floatingInput">Nama Pelanggan</label>
        </div>
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="floatingPassword" v-model="lastestTicket.noTicket" disabled>
          <label for="floatingPassword">Nomor Ticket</label>
        </div>
        <div class="form-floating mb-3">
          <input type="text" class="form-control bg-soft-success" id="floatingPassword" v-model="lastestTicket.status" disabled>
          
          <label for="floatingPassword">Status Ticket</label>
        </div>
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="floatingPassword" v-model="lastestTicketStageHolder" disabled>
          <label for="floatingPassword">Proses Penangganan</label>
        </div>
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="floatingPassword" v-model="lastestTicket.priority" disabled>
          <label for="floatingPassword">Prioritas</label>
        </div>
        <div class="form-floating mb-3" >
          <input type="text" class="form-control" id="floatingPassword" v-model="lastestTicket.category" disabled>
          <label for="floatingPassword">Kategori</label>
        </div>



        <template #modal-footer>
        <div class="w-100">
         
          
          <b-button
            variant="primary"
            size="sm"
            class="float-end"
            @click="hidemodalLastTicket"
          >
            Close
          </b-button>
        </div>
      </template>
      <template #modal-header> 
        <h4>Ticket Terbaru</h4></template>

    
        </b-modal>

        <b-modal id="modal-center" ref="modal-solved" centered title="Ticket Selesai " title-class="font-18" size="xl">
          
        <div >
          <b-table  head-variant="light" :items="dataCloseTicket" :fields="fieldsDataCloseTicket"
                    show-empty striped>
                <template v-slot:cell(status)="data">
                  <div class="badge rounded-pill bg-soft-success font-size-14 font-weight-bold" :class="{
                    'bg-soft-success': data.item.status === 'closed',
                    'bg-soft-danger': data.item.status === 'open'
                  }">
                    {{ data.item.status }}
                  </div>
                </template>
                    <template #empty>
                      <h5>Tidak ada data</h5> 
                    </template>
                    <template #table-busy>
                      <div class="text-center  my-2">
                        <b-spinner class="xs-1" variant="primary"></b-spinner>
                        <strong>Memuat data...</strong>
                      </div>
                    </template>
                  
                  </b-table>
        </div>


          <template #modal-footer>
          <div class="w-100">
              
            <b-button
              variant="primary"
              size="sm"
              class="float-end"
              @click="hidemodalSolved"
            >
              Close
            </b-button>
          </div>
        </template>
        <template #modal-header> 
          <h4>Ticket Terbaru</h4></template>

      
        </b-modal>

        <b-modal id="modal-center" ref="modal-open" centered title="Open Ticket " title-class="font-18" size="xl">
          
          <div >
            <b-table  head-variant="light" :items="dataOpenTicked" :fields="fieldsDataOpenTicket"
                      show-empty striped>
                      
                      <template v-slot:cell(status)="data">
                    <div class="badge rounded-pill bg-soft-success font-size-14 font-weight-bold" :class="{
                      'bg-soft-success': data.item.status === 'closed',
                      'bg-soft-danger': data.item.status === 'open'
                    }">
                      {{ data.item.status }}
                    </div>
                  </template>
                      <template #empty>
                        <h5>Tidak ada data</h5> 
                      </template>
                      <template #table-busy>
                        <div class="text-center  my-2">
                          <b-spinner class="xs-1" variant="primary"></b-spinner>
                          <strong>Memuat data...</strong>
                        </div>
                      </template>
                    
                    </b-table>
          </div>
  
  
            <template #modal-footer>
            <div class="w-100">
                
              <b-button
                variant="primary"
                size="sm"
                class="float-end"
                @click="hidemodalOpen"
              >
                Close
              </b-button>
            </div>
          </template>
          <template #modal-header> 
            <h4>Ticket Terbaru</h4></template>
  
        
          </b-modal>


      
    <!-- end col-->
</div>

<!-- end row--></template>
<style>

</style>